import axios from "axios";

export function hasPermissionAPI(permission) {

    const metaData = {
        withCredentials: true,
    };

    return new Promise((resolve) => {
        axios.post(`${process.env.REACT_APP_BACKEND}/permission`, { "permission": permission }, metaData)
        .then((response) => resolve(response.data))
        .catch((e) => {
            resolve({"hasPermission": false})
        })
    })
}